import { render, staticRenderFns } from "./backupsList.vue?vue&type=template&id=4bba9842"
import script from "./backupsList.vue?vue&type=script&lang=js"
export * from "./backupsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports